const PlusIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      fill="#181A1C"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
    >
      <path
        d="M22 15.333h-5.333V10h-1.334v5.333H10v1.334h5.333V22h1.334v-5.333H22v-1.334z"
        fill="current"
      ></path>
    </svg>
  );
};

export default PlusIcon;
